<div class="layout-content">
<form (ngSubmit)="submit()" [formGroup]="addCalendarForm">
  	<div class="grid">
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }} {{ 'CALENDAR' | translate | lowercase }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						id="calendar-add-input-name"
						formControlName="name"
						autocomplete="calendar-name"
						placeholder="{{ 'NAME' | translate }}"
						maxlength="33"
					/>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
		</div>
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.description, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION' | translate }} {{ 'CALENDAR' | translate | lowercase }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.description, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						id="calendar-add-input-description"
						formControlName="description"
						autocomplete="calendar-description"
						placeholder="{{ 'DESCRIPTION' | translate }}"
						maxlength="33"
					/>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="submit" pButton pRipple
			label="{{ 'CONFIRM' | translate }}"
			class="p-button-primary text-xl font-normal mt-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CANCEL' | translate }}"
			class="p-button-secondary text-xl font-normal mt-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
  </form>
</div>
